__turbopack_context__.v({
  "form": "register-module-scss-module__unxc4q__form",
  "formContent": "register-module-scss-module__unxc4q__formContent",
  "formPanel": "register-module-scss-module__unxc4q__formPanel",
  "imagebox": "register-module-scss-module__unxc4q__imagebox",
  "imageboxLogo": "register-module-scss-module__unxc4q__imageboxLogo",
  "logoMobile": "register-module-scss-module__unxc4q__logoMobile",
  "page": "register-module-scss-module__unxc4q__page",
  "promoDashboardImage": "register-module-scss-module__unxc4q__promoDashboardImage",
  "promoPanel": "register-module-scss-module__unxc4q__promoPanel",
});
